import React from 'react';
import PropTypes from 'prop-types';

const CardBox = ({ children, height = '100vh', id, margin = '7px' }) => (
  <div
    id={id}
    style={{
      height,
      backgroundColor: '#fff',
      margin,
      position: 'relative',
      overflow: 'auto',
      paddingLeft: '10px',
    }}
  >
    {children}
  </div>
);

CardBox.propTypes = {
  children: PropTypes.node.isRequired,
  height: PropTypes.string,
  id: PropTypes.string,
};

export default CardBox;
